import * as React from 'react';
import { PageWrapper } from '../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../uiComponents/layout/SectionGroup';
import { Section } from '../uiComponents/layout/Section';
import { createApiCaller } from '../infrastructure/api/ApiFactory';
import { Form } from '../uiComponents/bootstrap-components/BootstrapComponents';
import { setHoldListCache } from '../infrastructure/HoldListCache';
import NotificationModule from '../uiComponents/layout/Notification';
import { TextFormGroup } from '../uiComponents/input/FormGroups';
import SubmitButton from '../uiComponents/input/SubmitButton';

export interface LogIndSomAndenBrugerProps {
}

export interface LogIndSomAndenBrugerState {
    brugernavn: string;
}

export default class LogIndSomAndenBruger extends React.Component<LogIndSomAndenBrugerProps, LogIndSomAndenBrugerState> {
    constructor(props: LogIndSomAndenBrugerProps) {
        super(props);

        this.state = { 
            brugernavn: ''
        };
    }

    onImpersonateClick() {
        const apiCaller = createApiCaller();
        apiCaller.impersonateBruger(this.state.brugernavn).then(response => {
            if (response.ingenInstitutionstilknytninger !== undefined) {
                window.location.href = '/ingen-institutioner';
            } else {
                localStorage.setItem('token', response.token);
                apiCaller.getHoldList().then(hold => {
                    setHoldListCache(hold);
                    NotificationModule.showSuccess('', 'Du er nu logget ind som ' + this.state.brugernavn, false);
                    window.location.href = '/';
                });
            }
        });
    }

    render() {
        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup header='Log ind som anden bruger'>
                        <Form onSubmit={() => this.onImpersonateClick()}>
                            <Section>
                                <TextFormGroup
                                    errorMessages={[]}
                                    label='Brugernavn*'
                                    name='brugernavn'
                                    placeholder='Brugernavn...'
                                    value={this.state.brugernavn}
                                    onChange={(name: string, value: string) => this.setState({ brugernavn: value.trim() })}
                                    autoFocus={true}
                                />
                                <br />
                                <br />
                                <SubmitButton isSubmitting={false}>Log ind</SubmitButton>
                            </Section>
                        </Form>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/LogIndSomAndenBruger.tsx